import * as React from 'react';
import { FormField, Input } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { InjectedTranslateProps, translate } from 'react-i18next';
import { TextAndStyleSettingsButtonMaxLength } from '@src/constants/constants';

const MAX_LEN = TextAndStyleSettingsButtonMaxLength;

interface Props extends InjectedTranslateProps {
  value: string;
  onChange: (value: string) => void;
}

const SettingsButtonEditorBase = ({ t, value, onChange }: Props) => (
  <FormField
    label={t('text-and-display.setting-button.title')}
    infoContent={t('text-and-display.setting-button.tooltip')}
    charCount={MAX_LEN - value.length}
  >
    <Input
      dataHook={DataHooks.TextAndDisplaySetting}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      maxLength={MAX_LEN}
    />
  </FormField>
);

export const SettingsButtonEditor = translate()(SettingsButtonEditorBase);
